import { kEditorSelector } from "@protontech/autofill/constants/selectors";
import { matchIFrameField } from "./re";
import { sanitizeStringWithSpaces } from "./text";

/** Check if iframe likely contains form fields. Conservative to
 * exclude trackers, ads, and other non-form iframes. */
export const isIFrameField = (iframe: HTMLIFrameElement) => {
  const title = iframe.getAttribute("title") ?? "";
  const name = iframe.getAttribute("name") ?? "";
  const ariaLabel = iframe.getAttribute("aria-label") ?? "";
  const id = iframe.id;
  const src = iframe.src.substring(0, 150);
  const className = iframe.className.substring(0, 150);

  const haystack = sanitizeStringWithSpaces(`${title} ${name} ${ariaLabel} ${id} ${src} ${className}`);
  return matchIFrameField(haystack);
};

export const isEditorFrame = () => {
  if (document.designMode === "on") return true;
  if (document.body?.isContentEditable) return true;
  return document.querySelector(kEditorSelector) !== null;
};
